import { Box, Container, Grid, Typography } from "@mui/material";

export default function Footer() {

    return (
        <Box
          sx={{
            width: "100%",
            height: "auto",
            backgroundColor: "#222",
            paddingTop: "1rem",
            paddingBottom: "1rem",
          }}
        >
          <Container maxWidth="lg">
            <Grid container direction="column" alignItems="center">
              <Grid item xs={12}>
                <Typography color="#aaa" variant="subtitle1">
                  {`Copyright ${new Date().getFullYear()} Akhil AS`}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
      );

}